// see https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_SignUp.html#API_SignUp_Errors

const ERRORS = [
  {
    code: 'AccessDeniedException',
    msg: 'Du hast hierauf leider keinen Zugriff.',
  },
  {
    code: 'IncompleteSignature',
    msg: 'Die Request Signatur entspricht nicht den AWS Standards.',
  },
  {
    code: 'InternalFailure',
    msg: 'Der Request konnte wegen einem AWS internen Fehler nicht abgeschlossen werden.',
  },
  {
    code: 'InvalidAction',
    msg: 'Diese Aktion ist unzulässig.',
  },
  {
    code: 'InvalidClientTokenId',
    msg: 'Das verwendete Client Token ist ungültig.',
  },
  {
    code: 'InvalidParameterCombination',
    msg: 'Die Parameter dürfen nicht gemeinsam verwendet werden.',
  },
  {
    code: 'InvalidParameterValue',
    msg: 'Der Parameter enthält einen ungültigen Wert.',
  },
  {
    code: 'InvalidQueryParameter',
    msg: 'Der AWS Query Parameter entspricht nicht den AWS Standards.',
  },
  {
    code: 'MalformedQueryString',
    msg: 'Der AWS Query Parameter ist syntaktisch ungültig.',
  },
  {
    code: 'MissingAction',
    msg: 'Dem Request fehlt eine Aktion oder ein benötigter Parameter.',
  },
  {
    code: 'MissingAuthenticationToken',
    msg: 'Das Authentifizierungstoken fehlt.',
  },
  {
    code: 'MissingParameter',
    msg: 'Ein benötigter Parameter fehlt.',
  },
  {
    code: 'NotAuthorized',
    msg: 'Du hast nicht die Berechtigung diese Aktion auszuführen.',
  },
  {
    code: 'OptInRequired',
    msg: 'Dem AWS Access Key fehlt eine Service-Registrierung.',
  },
  {
    code: 'RequestExpired',
    msg: 'Der Request ist abgelaufen.',
  },
  {
    code: 'ServiceUnavailable',
    msg: 'Der Request schlug aufgrund eines temporären Serverfehlers fehl.',
  },
  {
    code: 'ThrottlingException',
    msg: 'Der Request schlug aufgrund einer Drosselung fehl.',
  },
  {
    code: 'ValidationError',
    msg: 'Die Eingaben entsprechen nicht den AWS Standards.',
  },
  {
    code: 'QuotaExceededException',
    msg: 'Dein Portfolio konnte nicht erfolgreich erstellt werden. Die maximale Anzahl von 150 Portfoliopositionen wurde überschritten.',
  },
]

export {ERRORS}
